import AuthUtil from './AuthUtil';
import {
  ADMIN_GROUP_A,
  ADMIN_GROUP_B,
  GROUP_TYPE_BSC,
  ADMIN_TYPE_BSC,
  ADMIN_TYPE_GROUP_A,
  ADMIN_TYPE_GROUP_B,
} from '../constants/AppConstants';

class Auth {
  static storeUserAccess({
    userData, tokenData, token, refreshToken, authData
  }) {
    sessionStorage.setItem('userAccess', JSON.stringify({
      admin: AuthUtil.isAdminUser(authData),
      stdUser: AuthUtil.isStdUser(authData),
      legacyUser: AuthUtil.isLegacyUser(authData, userData, tokenData),
      token,
      refreshToken,
      groups: authData?.groups ?? [],
    }));
  }

  static retrieveToken() {
    return JSON.parse(sessionStorage.getItem('userAccess'))?.token;
  }

  static validUser() {
    const userAccess = JSON.parse(sessionStorage.getItem('userAccess'));
    return userAccess?.admin || userAccess.legacyUser || userAccess.stdUser;
  }

  static logout() {
    sessionStorage.clear();
  }

  static removeToken() {
    sessionStorage.removeItem('userAccess');
  }

  static retrieveUserAccess() {
    return JSON.parse(sessionStorage.getItem('userAccess'));
  }

  static isAuthorized() {
    return this.retrieveToken() && this.validUser();
  }

  static getGroups() {
    return this.retrieveUserAccess()?.groups ?? [];
  }

  static getAdminType() {
    const groups = this.getGroups();
    if (groups.includes(GROUP_TYPE_BSC)) {
      return ADMIN_TYPE_BSC;
    }
    if (groups.some((grp) => ADMIN_GROUP_A.includes(grp))) {
      return ADMIN_TYPE_GROUP_A;
    }
    if (groups.some((grp) => ADMIN_GROUP_B.includes(grp))) {
      return ADMIN_TYPE_GROUP_B;
    }
    return null;
  }
}

export default Auth;
